import { assertInInjectionContext, inject } from "@angular/core";
import { LANGUAGE, Language } from "../shared/models/language.model";
import { TranslateService } from "@ngx-translate/core";


// Helper function for getting the currency code
export function getCurrencyCode(): string {
    assertInInjectionContext(getCurrencyCode);
    const languages: Language[] = inject(LANGUAGE);
    const translateService = inject(TranslateService);
    const currentLang = translateService.currentLang;
    return languages.find((lang: Language) => lang.lang === currentLang)?.currencyCode ?? languages[0].currencyCode;
}